import React from "react";

import MainDashboard from "views/admin/default";
import NFTMarketplace from "views/admin/marketplace";
import Profile from "views/admin/profile";
import DataTables from "views/admin/tables";
import Organizers from "views/admin/companies";
import CreateOrganizer from "views/admin/companies/Create";
import MasterCompanyCreate from "views/admin/masterCompanies/Create";
import EditOrganizer from "views/admin/companies/Edit";
import ViewOrganizer from "views/admin/companies/View";
import Exhibitors from "views/admin/exhibitors";
import CreateExhibitor from "views/admin/exhibitors/Create";
import EditExhibitor from "views/admin/exhibitors/Edit";
import ViewExhibitor from "views/admin/exhibitors/View";
import Products from "views/admin/products";
import CreateProduct from "views/admin/products/Create";
import EditProduct from "views/admin/products/Edit";
import ViewProduct from "views/admin/products/View";
import CreateEvent from "views/admin/events/Create";
import EditEvent from "views/admin/events/Edit";
import ViewEvent from "views/admin/events/View";
import Events from "views/admin/events/";
import ExhibitorEvents from "views/admin/exhibitorEvents/";
import Offers from "views/admin/offers";
import CreateOffer from "views/admin/offers/Create";
import EditOffer from "views/admin/offers/Edit";
import ViewOffer from "views/admin/offers/View";
import Articles from "views/admin/articles";
import CreateArticle from "views/admin/articles/Create";
import EditArticle from "views/admin/articles/Edit";
import ViewArticle from "views/admin/articles/View";
import CreateExhibitorEvent from "views/admin/exhibitorEvents/Create";
import EditExhibitorEvent from "views/admin/exhibitorEvents/Edit";
import ViewExhibitorEvent from "views/admin/exhibitorEvents/View";
import ProductCategory from "views/admin/settings/ProductCategory";
import Pavilion from "views/admin/settings/Pavilion";
import Currency from "views/admin/settings/Currency";
import Coupons from "views/admin/settings/Coupon";
import ExhibitorCategory from "views/admin/settings/ExhibitorCategory";
import EventCategory from "views/admin/settings/EventCategory";
import Banners from "views/admin/banners/";
import BannerIndex from "views/admin/banners/bannerIndex";
import RTLDefault from "views/rtl/default";
import BulkNotification from "views/admin/bulkNotification";
import FloorMap from "views/admin/floorMap";
import FloorMapBuilder from "views/admin/floorMap/Builder";
import MasterCompanies from "views/admin/masterCompanies";
import EditMasterCompany from "views/admin/masterCompanies/Edit";

import SignIn from "views/auth/SignIn";
import ForgotPassword from "views/auth/ForgotPassword";
import VerifyOtp from "views/auth/VerifyOtp";
import ResetPassword from "views/auth/ResetPassword";
import Visitors from "views/admin/visitor";
import Scanners from "views/admin/scanners";
import ScannerCreate from "views/admin/scanners/Create";
import ScannerEdit from "views/admin/scanners/Edit";

import {
  MdHome,
  MdOutlineShoppingCart,
  MdBarChart,
  MdPerson,
  MdLock,
  MdTrolley,
  MdBusiness,
  MdSettings,
  MdCategory,
  MdEvent,
  MdEventAvailable,
  MdPlace,
  MdProductionQuantityLimits,
  MdLocalOffer,
  MdCurrencyExchange,
  MdPostAdd,
  MdImage,
  MdArticle,
  MdNotifications,
  MdMap,
  MdQrCodeScanner, // Icon for Scanners
  MdHowToReg,
  MdMic,
  MdViewAgenda,

} from "react-icons/md";
import { HiTable } from "react-icons/hi";
import Speakers from "views/admin/speakers";
import CreateSpeaker from "views/admin/speakers/Create";
import EditSpeaker from "views/admin/speakers/Edit";
import ProgramTypes from "views/admin/settings/ProgramType";
import Programs from "views/admin/program";
import CreateProgram from "views/admin/program/Create";
import EditProgram from "views/admin/program/Edit";
import Dashboard from "views/admin/dashboard";

const routes = [
  {
    name: "Main Dashboard",
    layout: "/admin",
    path: "default",
    icon: <MdHome className="h-6 w-6" />,
    component: <MainDashboard />,
    hidden: true,
  },
  {
    name: "NFT Marketplace",
    layout: "/admin",
    path: "nft-marketplace",
    icon: <MdOutlineShoppingCart className="h-6 w-6" />,
    component: <NFTMarketplace />,
    secondary: true,
    hidden: true,
  },
  {
    name: "Data Tables",
    layout: "/admin",
    icon: <MdBarChart className="h-6 w-6" />,
    path: "data-tables",
    component: <DataTables />,
    hidden: true,
  },
  {
    name: "Profile",
    layout: "/admin",
    path: "profile",
    icon: <MdPerson className="h-6 w-6" />,
    component: <Profile />,
    hidden: true,
  },
  {
    name: "Sign In",
    layout: "/auth",
    path: "sign-in",
    icon: <MdLock className="h-6 w-6" />,
    component: <SignIn />,
    hidden: true,
  },
  {
    name: "Forgot Password",
    layout: "/auth",
    path: "forgot-password",
    component: <ForgotPassword />,
    hidden: true,
  },
  {
    name: "Verify OTP",
    layout: "/auth",
    path: "verify-otp",
    component: <VerifyOtp />,
    hidden: true,
  },
  {
    name: "Reset Password",
    layout: "/auth",
    path: "reset-password",
    component: <ResetPassword />,
    hidden: true,
  },
  // {
  //   name: "RTL Admin",
  //   layout: "/rtl",
  //   path: "rtl",
  //   icon: <MdHome className="h-6 w-6" />,
  //   component: <RTLDefault />,
  // },
    {
    name: "Dashboard",
    key: "dashboard",
    layout: "/admin",
    path: "dashboard",
    icon: <MdBusiness />,
    component: <Dashboard />,
  },
  {
    name: "Master Companies",
    key: "master",
    layout: "/admin",
    path: "master",
    icon: <MdBusiness />,
    component: <MasterCompanies />,
  },
  {
    layout: "/admin",
    path: "master/create",
    component: <MasterCompanyCreate />,
    hidden: true,
  },
  {
    layout: "/admin",
    path: "master/edit/:id",
    component: <EditMasterCompany />,
    hidden: true,
  },
  {
    name: "Master Event",
    key: "organizers",
    layout: "/admin",
    path: "companies",
    icon: <MdEvent />,
    component: <Organizers />,
  },
  {
    layout: "/admin",
    path: "companies/create",
    component: <CreateOrganizer />,
    hidden: true,
  },
  {
    layout: "/admin",
    path: "companies/edit/:id",
    component: <EditOrganizer />,
    hidden: true,
  },
  {
    layout: "/admin",
    path: "companies/view/:id",
    component: <ViewOrganizer />,
    hidden: true,
  },
  {
    name: "Exhibitors",
    layout: "/admin",
    path: "exhibitors",
    component: <Exhibitors />,
    key: "exhibitors",
  },
  {
    layout: "/admin",
    path: "exhibitors/create",
    component: <CreateExhibitor />,
    hidden: true,
  },
  {
    layout: "/admin",
    path: "exhibitors/edit/:id",
    component: <EditExhibitor />,
    hidden: true,
  },
  {
    layout: "/admin",
    path: "exhibitors/view/:id",
    component: <ViewExhibitor />,
    hidden: true,
  },
  {
    name: "Products",
    layout: "/admin",
    path: "products",
    icon: <MdTrolley />,
    component: <Products />,
    key: "products",
  },
  {
    layout: "/admin",
    path: "products/create",
    component: <CreateProduct />,
    hidden: true,
  },
  {
    layout: "/admin",
    path: "products/edit/:id",
    component: <EditProduct />,
    hidden: true,
  },
  {
    layout: "/admin",
    path: "products/view/:id",
    component: <ViewProduct />,
    hidden: true,
  },

  {
    name: "Articles",
    layout: "/admin",
    path: "articles",
    icon: <MdArticle />,
    component: <Articles />,
    key: "articles",
  },
  {
    layout: "/admin",
    path: "articles/create",
    component: <CreateArticle />,
    hidden: true,
  },
  {
    layout: "/admin",
    path: "articles/edit/:id",
    component: <EditArticle />,
    hidden: true,
  },
  {
    layout: "/admin",
    path: "articles/view/:id",
    component: <ViewArticle />,
    hidden: true,
  },
  {
    name: "Events",
    layout: "/admin",
    path: "events",
    icon: <MdEvent />,
    component: <Events />,
    key: "events",
  },
  {
    layout: "/admin",
    path: "events/create",
    component: <CreateEvent />,
    hidden: true,
  },
  {
    layout: "/admin",
    path: "events/edit/:id",
    component: <EditEvent />,
    hidden: true,
  },
  {
    layout: "/admin",
    path: "events/view/:id",
    component: <ViewEvent />,
    hidden: true,
  },
  {
    name: "Exhibitor Events",
    layout: "/admin",
    path: "exhibitor-events",
    icon: <MdEventAvailable />,
    component: <ExhibitorEvents />,
    key: "exhibitor-events",
    hidden: true,
  },
  {
    layout: "/admin",
    path: "exhibitor-events/create",
    component: <CreateExhibitorEvent />,
    hidden: true,
  },
  {
    layout: "/admin",
    path: "exhibitor-events/edit/:id",
    component: <EditExhibitorEvent />,
    hidden: true,
  },
  {
    layout: "/admin",
    path: "exhibitor-events/view/:id",
    component: <ViewExhibitorEvent />,
    hidden: true,
  },
  {
    name: "Offers",
    layout: "/admin",
    path: "offers",
    icon: <MdLocalOffer />,
    component: <Offers />,
    key: "offers",
  },
  {
    layout: "/admin",
    path: "offers/create",
    component: <CreateOffer />,
    hidden: true,
  },
  {
    layout: "/admin",
    path: "offers/edit/:id",
    component: <EditOffer />,
    hidden: true,
  },
  {
    layout: "/admin",
    path: "offers/view/:id",
    component: <ViewOffer />,
    hidden: true,
  },
  {
    name: "Visitors",
    layout: "/admin",
    path: "visitor",
    icon: <MdHowToReg />,
    component: <Visitors />,
    key: "visitors",
  },
  {
    name: "Scanners",
    layout: "/admin",
    path: "scanners",
    icon: <MdQrCodeScanner />,
    component: <Scanners />,
    key: "scanners",
  },
  {
    name: "Scanner Create",
    layout: "/admin",
    path: "scanners/create",
    component: <ScannerCreate />,
    hidden: true,
  },
  {
    name: "Scanner Edit",
    layout: "/admin",
    path: "scanners/edit/:id",
    component: <ScannerEdit />,
    hidden: true,
  },
    {
    name: "Programs",
    layout: "/admin",
    path: "program",
    icon: <MdViewAgenda />,
    component: <Programs />,
    key: "program",
  },
  {
    name: "Program Create",
    layout: "/admin",
    path: "program/create",
    component: <CreateProgram />,
    hidden: true,
  },
  {
    name: "Program Edit",
    layout: "/admin",
    path: "program/edit/:id",
    component: <EditProgram />,
    hidden: true,
  },
  {
    name: "Speakers",
    layout: "/admin",
    path: "speakers",
    icon: <MdMic />,
    component: <Speakers />,
    key: "speaker",
  },
  {
    name: "Speaker Create",
    layout: "/admin",
    path: "speakers/create",
    component: <CreateSpeaker />,
    hidden: true,
  },
  {
    name: "Speaker Edit",
    layout: "/admin",
    path: "speakers/edit/:id",
    component: <EditSpeaker />,
    hidden: true,
  },
  {
    name: "Banner",
    layout: "/admin",
    path: "banners",
    icon: <MdPostAdd className="h-6 w-6" />,
    children: [
      {
        name: "Add Banner",
        layout: "/admin",
        path: "banners/add",
        icon: <MdImage className="h-5 w-5" />,
        component: <Banners />,
        key: "banners-add",
      },
      {
        name: "Hero View All",
        layout: "/admin",
        path: "banners/herolist",
        icon: <MdImage className="h-5 w-5" />,
        component: <BannerIndex />,
        key: "banners-hero",
      },
      {
        name: "Popup View All",
        layout: "/admin",
        path: "banners/popuplist",
        icon: <MdImage className="h-5 w-5" />,
        component: <BannerIndex />,
        key: "banners-popup",
      },
      {
        name: "Bubble View All",
        layout: "/admin",
        path: "banners/bubblelist",
        icon: <MdImage className="h-5 w-5" />,
        component: <BannerIndex />,
        key: "banners-bubble",
      },
      {
        name: "Flash View All",
        layout: "/admin",
        path: "banners/flashlist",
        icon: <MdImage className="h-5 w-5" />,
        component: <BannerIndex />,
        key: "banners-flash",
      },
    ],
  },
  {
    name: "Bulk Notification",
    layout: "/admin",
    path: "bulk-notification",
    icon: <MdNotifications className="h-6 w-6" />,
    component: <BulkNotification />,
    key: "bulk-notification",
  },
  {
    name: "Floor Map",
    layout: "/admin",
    path: "floor-map",
    icon: <MdMap className="h-6 w-6" />,
    component: <FloorMap />,
    key: "floor-map",
  },
  {
    layout: "/admin",
    path: "floor-map/builder/:id",
    component: <FloorMapBuilder />,
    hidden: true,
  },
  {
    name: "Settings",
    layout: "/admin",
    path: "settings",
    icon: <MdSettings className="h-6 w-6" />,
    key:"settings",
    children: [
      {
        name: "Product Categories",
        layout: "/admin",
        path: "settings/product-categories",
        icon: <MdCategory className="h-5 w-5" />,
        component: <ProductCategory />,
        key: "product-categories",
      },
      {
        name: "Event Categories",
        layout: "/admin",
        path: "settings/event-categories",
        icon: <MdCategory className="h-5 w-5" />,
        component: <EventCategory />,
        key: "event-categories",
      },
      {
        name: "Pavilions",
        layout: "/admin",
        path: "settings/pavilions",
        icon: <MdPlace className="h-5 w-5" />,
        component: <Pavilion />,
        key: "pavilions",
      },
      {
        name: "Exhibitor Categories",
        layout: "/admin",
        path: "settings/exhibitor-categories",
        icon: <MdCategory className="h-5 w-5" />,
        component: <ExhibitorCategory />,
        key: "exhibitor-categories",
      },
      {
        name: "Currency",
        layout: "/admin",
        path: "settings/currency",
        icon: <MdCurrencyExchange className="h-5 w-5" />,
        component: <Currency />,
        key: "currency",
      },
      {
        name: "Coupon",
        layout: "/admin",
        path: "settings/coupan",
        icon: <MdCurrencyExchange className="h-5 w-5" />,
        component: <Coupons />,
        key: "coupan",
      },
      // {
      //   name: "Program Type",
      //   layout: "/admin",
      //   path: "settings/program-type",
      //   icon: <MdCurrencyExchange className="h-5 w-5" />,
      //   component: <ProgramTypes />,
      //   key: "program-type",
      // },
    ],
  },
];
export default routes;
